/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateNotificationPreferenceMutationRequest,
  UpdateNotificationPreferenceMutationResponse,
  UpdateNotificationPreference400,
} from '../types/UpdateNotificationPreference'

function getUpdateNotificationPreferenceUrl() {
  const res = {
    method: 'PATCH',
    url: `/api/v1/notifications/preferences/` as const,
  }
  return res
}

/**
 * @summary Update a single preference's email / in-app toggles for the current user
 * {@link /api/v1/notifications/preferences/}
 */
export async function updateNotificationPreference(
  data?: UpdateNotificationPreferenceMutationRequest,
  config: Partial<
    RequestConfig<UpdateNotificationPreferenceMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateNotificationPreferenceMutationResponse,
    ResponseErrorConfig<UpdateNotificationPreference400>,
    UpdateNotificationPreferenceMutationRequest
  >({
    method: 'PATCH',
    url: getUpdateNotificationPreferenceUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
